import { formatters, ValueInput } from '@utils/formattersV2';

type Formatter = (value: ValueInput) => string;

export const formatAveragePurchaseFrequency: Formatter = value =>
  formatters.number(value, { decimals: 1 });
